import baseRequest, { setToken } from "./baseRequest";

export const authenticationServices = {
  register: async (data) => baseRequest(data, "/authenticate/register", "post"),

  login: async (data) => {
    const res = await baseRequest(data, "/authenticate", "post");
    if (!res.isSuccess) {
      return res;
    }
    setToken(res.data);
    localStorage.setItem("token", JSON.stringify(res.data));
    localStorage.setItem("user", JSON.stringify(res.data.user));
    return res;
  },


  getShopUser: async () => {
    const res = await baseRequest(null, "/shop/GetShopWithUser", "get",true);
    if (res.isSuccess) {
      localStorage.setItem("SHCS", JSON.stringify(res.data));
      return res;
    }
  },






  logout: async (data) => {
    localStorage.clear();
  },
  loginWithToken: async () => {
    const data = JSON.parse(localStorage.getItem("token"));
    if (!data) {
      window.location.reload();
    }
    const res = await baseRequest(null, "/authenticate/NewToken/" + data.refreshToken, "post", false, 
    null, null, false, null, null, null, true);
   
    if (res.isSuccess) {
      setToken(res.data);
      localStorage.setItem("token", JSON.stringify(res.data));
      return res;
    }
    return null;
  },

  isAuthenticate: () => (localStorage.getItem("token") ? true : false),
  tempUser: () => {
    return { imageUrl: "", jobTitle: "", fullName: "" };
  },
  userInfo: async () =>
    localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : { imageUrl: "", jobTitle: "", fullName: "" },
};
